import styled from 'styled-components';
import {MdKeyboardArrowRight, MdArrowForward} from 'react-icons/md';
import { Link } from 'react-router-dom';

export const BannerContainer = styled.div`
  background: #0c0c0c;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 30px;
  height: ${({height}) => (height ? '800px' : '400px')};
  position: relative;
  z-index: 1;
  :before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: background: linear-gradient(
      180deg,
      rgba(0,0,0,0.1) 0%,
      rgba(0,0,0,0.3) 100%),
      linear-gradient(180deg, rgba(0,0,0,0.2) 0%, transparent 100%);
    z-index: 2;

    background-image : linear-gradient(
                      180deg,
                      rgba(${({darkTop}) => (darkTop ? 1 : 255)},${({darkTop}) => (darkTop ? 6 : 207)},${({darkTop}) => (darkTop ? 6 : 235)}, ${({darkTop}) => (darkTop ? .6 : 1)}),
                      rgba(${({darkTop}) => (darkTop ? 1 : 255)},${({darkTop}) => (darkTop ? 6 : 255)},${({darkTop}) => (darkTop ? 6 : 255)}, ${({darkTop}) => (darkTop ? .2 : 0)}),
                      rgba(255,255,255, 0),
                      rgba(255,207,235, 1) 100%),
                      linear-gradient(180deg, rgba(0,0,0,0.2) 0%, transparent 100%);

  }
`

export const ImgBg = styled.img`
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  background: #232a34;
`

export const VideoBg = styled.video`
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  background: #232a34;
`

export const BannerBg = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

export const BannerContent = styled.div`
  z-index: 3;
  max-width: 1200px;
  position: absolute;
  padding: 8px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const BannerH1 = styled.h1`
color: white;
text-shadow: 2px 2px 8px #000;
  font-size: 48px;
  text-align: center;

  @media screen and (max-width: 768px) {
    font-size: 40px;
  }

  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`

export const BannerP = styled.p`
  margin-top: 24px;
  color: white;
  text-shadow: 2px 2px 8px #000;
  font-size: 24px;
  text-align: center;
  max-width: 600px;

  @media screen and (max-width: 768px) {
    font-size: 24px;
  }

  @media screen and (max-width: 480px) {
    font-size: 18px;
  }
`
export const BannerBtnWrapper = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
    width: 90%;
`

export const BannerBtnLink = styled.a`
  border-radius: 50px;
  background: #ffcfeb;
  white-space: nowrap;
  padding: 10px 22px;
  color: #010606;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #010606;
  }
`

export const ArrowForward = styled(MdArrowForward)`
  margin-left: 8px;
  font-size: clamp(16px, 2.5vw, 20px);
`;

export const ArrowRight = styled(MdKeyboardArrowRight)`
  margin-left: 8px;
  font-size: clamp(16px, 2.5vw, 20px);
`;
